<template>
  <v-card flat>
    <h2>{{$t('settings.choose-role-title')}}</h2>
    <v-form ref="form" @submit.prevent="submit" validate-on="input">
      <v-select outlined
        class="mt-6"
        :items="items"
        append-icon="$sl-arrow-down"
        :rules="[rules.required]"
        v-model="role"
      />
      <v-btn type="submit" block class="btn-label application" color="primary">
        <v-icon>$sl-save</v-icon>
        {{ $t('labels.save') }}
      </v-btn>
    </v-form>
  </v-card>
</template>
<script>
import {RulesMixin} from '@/components/mixins'

export default {
  name: 'ChooseRole',
  mixins: [RulesMixin],
  props:{
    roleList: { type: Array, required: true}
  },
  data: () => ({
    role: null,
  }),

  computed:{
    items(){
      return this.roleList.map(value => ({text: this.$t(`roles.${value}`), value}))
    }
  },
  methods:{
    submit(){
      if(!this.$refs.form.validate()){
        return 
      }

      this.$emit('confirm', this.role)
    }
  }
}
</script>